import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const PasswordChecksList = styled.ul``

export const PasswordChecksItem = styled.li`
  display: flex;
  align-items: center;
`

export const IconWrapper = styled.figure`
  display: flex;
  align-items: center;
  margin-right: ${Spacing.S8};
`
